import AddPbookBtnTnB from "./AddPbookBtnTnB";

export default AddPbookBtnTnB;



// WEBPACK FOOTER //
// ./src/componentsTnb/AddPbookBtnTnB/index.js